import type { ReactElement } from "react";
import { Link } from "react-router-dom";

/**
 * Cycle 8 STORY-701: Modern animated hero for HomePage (unauthenticated state).
 *
 * Visual: gradient mesh background + headline + subheading + dual CTA.
 * Animations: subtle gradient shift (CSS keyframes), respects prefers-reduced-motion.
 *
 * Replaces previous text-only ul-based hero on HomePage.
 */
export function HeroModern(): ReactElement {
  return (
    <section className="hero-modern" aria-labelledby="hero-title">
      <div className="hero-modern__bg" aria-hidden="true">
        <div className="hero-modern__mesh hero-modern__mesh--1" />
        <div className="hero-modern__mesh hero-modern__mesh--2" />
        <div className="hero-modern__mesh hero-modern__mesh--3" />
      </div>

      <div className="hero-modern__content">
        <span className="hero-modern__eyebrow">IT-Navigate Platform</span>
        <h1 id="hero-title" className="hero-modern__title">
          12 продуктов.
          <br />
          <span className="hero-modern__title-accent">Один портал.</span>
          <br />
          Реальные результаты.
        </h1>
        <p className="hero-modern__subtitle">
          Безопасность производства, оптимизация логистики, ML-прогнозы продаж и
          мониторинг качества — в едином коммерческом портфеле для российской
          промышленности.
        </p>

        <div className="hero-modern__ctas">
          <Link to="/request-demo" className="btn-primary hero-modern__cta-primary">
            Запросить демонстрацию →
          </Link>
          <Link to="/login" className="btn-secondary hero-modern__cta-secondary">
            У меня есть invite
          </Link>
        </div>

        <p className="hero-modern__note">
          Получили invite-ссылку от менеджера? Просто откройте её — регистрация
          не требуется.
        </p>
      </div>
    </section>
  );
}
